export default "__VITE_ASSET__893b2808__"